import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextareaAutosize } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  GetFacilityEmailID,
  getPatientDetails,
  GetStateDetailsById,
  InsertPPLogs,
  UpdateProfile,
  GetInsuranceDetails,
  getGuardianDetails,
} from "../../../../api"; //FB 8568
import useMediaQuery from "@mui/material/useMediaQuery";
import { Guardian, Patient } from "../../../../store";  //FB 8568

// Update log
// FB  6192   02/06/2023  DK  Added profile screen
// FB  8568   04/16/2024  DK  Guardian is not able to see the patient profile details
// FB  8638   04/25/2024  GA  PP : Transmit status is not showing for the Simple email and notify admin email

export default function Profile(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const JSAlert = require("js-alert");
  const [patient, setPatient] = useState<Patient>({} as Patient);
  const [guardian, setGuardian] = useState<Guardian>({} as Guardian); //FB 8568
  const [open, setOpen] = React.useState(false);
  const [details, setDetails] = useState("");
  const [isDisabled, setIsDisabled] = React.useState(true);
  const handleChange = (event: any) => {
    setDetails(event.target.value);
    if (details.length == 0) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };
  const styletwo = {
    container: {
      border: "1px grey",
      marginLeft: matches == false ? "16px" : "40px",
      marginBottom: "20px",
      marginTop: "10px",
    },
  };
  let patientName = "User";
  let userName: any;
  let isGuardian = false; //FB 8568
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
    isGuardian = JSON.parse(data).IsGuardian; //FB 8568
  }

  const handleEmail = async (event: any) => {
    var datasession = sessionStorage.getItem("user");
    if (datasession != null) {
      const user = JSON.parse(datasession);
      const userData = await GetFacilityEmailID(user.EMRID);
      if (userData.alertType == "Failed") {
        JSAlert.alert(userData.message, null, JSAlert.Icons.Failed);
      } else {
        if (userData != null) {
          if (user != null) {
            let content = details.replaceAll("\n", "<br>");
            let response = await UpdateProfile(
              user.EMRID,
              userData.PortalName,
              userData.FACILITY_NOTIFICAION_EMAIL,
              content
            );
            if (response != null) {
              if (response.alertType == "Success") {
                JSAlert.alert(response.message, null, JSAlert.Icons.Success);
              } else {
                JSAlert.alert(response.message, null, JSAlert.Icons.Failed);
              }
            }
            setOpen(false);
            InsertPPLogs(
              "Clicked on notify admin",
              window.location.href,
              userName,
              userData.FACILITY_NOTIFICAION_EMAIL,
              userData ? "Notified Admin" : "Error Occured" //FB 8638

            );
          } else {
            JSAlert.alert(
              "Please contact office as we are facing trouble sending email.",
              null,
              JSAlert.Icons.Failed
            );
            setOpen(false);
          }
        }
        console.log(data);
      }
    } else {
      alert("Please Enter Valid Details");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    setIsDisabled(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function GetPatientData() {
    if (props.isAdmin) {
      if (props.info.Login != undefined) {
        getPatientDetails(props.info.Login).then(async function (patientdata) {
          setPatient(patientdata as Patient);
          if (patientdata?.StateID != null) {
            var data = await GetStateDetailsById(
              (patientdata as Patient).StateID
            );
            setstatename(data.stateFullName);
          }
        });
      }
    } else {
      var data = sessionStorage.getItem("user");
      if (data != null) {
        const user = JSON.parse(data);
        //FB 8568
        if (user.IsGuardian) {
          getGuardianDetails(user.Guardian).then(async function (guardian) {
            setGuardian(guardian as Guardian);
          });
        } else {
          if (user.Patient_n != null) {
            getPatientDetails(user.Login).then(async function (patientdata) {
              setPatient(patientdata as Patient);
              if (patientdata?.StateID != null) {
                var data = await GetStateDetailsById(
                  (patientdata as Patient).StateID
                );
                setstatename(data.stateFullName);
              }
            });
          }
        }
      }
    }
  } //FB 8568

  async function GetInsuranceData() {
    if (props.isAdmin) {
      if (props.info.EMRID != undefined) {
        await GetInsuranceDetails(props.info.EMRID).then(async function (insurdata) {
          setInsuranceData(insurdata);
        });
      }
    } else {
      var data = sessionStorage.getItem("user");
      if (data != null) {
        const user = JSON.parse(data);
        if (user.Patient_n != null) {
          await GetInsuranceDetails(user.EMRID).then(async function (insurdata) {
            setInsuranceData(insurdata);
          });
        }
      }
    }
  }

  const [insuranceData, setInsuranceData] = React.useState<Array<CardProps>>([
    {
      PATIENT_INSURANCE_CARRIER_ID: "",
      PATIENT_INSURANCE_CARRIER: "",
      PATIENT_SECONDARY_INSURANCE_CARRIER_ID: "",
      PATIENT_SECONDARY_INSURANCE_CARRIER: "",
      PATIENT_THIRD_INSURANCE_CARRIER_ID: "",
      PATIENT_THIRD_INSURANCE_CARRIER: "",
      PATIENT_INSURANCE_CARRIER_GROUP: "",
      PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP: "",
      PATIENT_THIRD_INSURANCE_CARRIER_GROUP: "",
    },
  ]);
  type CardProps = {
    PATIENT_INSURANCE_CARRIER_ID: string;
    PATIENT_INSURANCE_CARRIER: string;
    PATIENT_SECONDARY_INSURANCE_CARRIER_ID: string;
    PATIENT_SECONDARY_INSURANCE_CARRIER: string;
    PATIENT_THIRD_INSURANCE_CARRIER_ID: string;
    PATIENT_THIRD_INSURANCE_CARRIER: string;
    PATIENT_INSURANCE_CARRIER_GROUP: string;
    PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP: string;
    PATIENT_THIRD_INSURANCE_CARRIER_GROUP: string;
  };
  const [employees, setEmployees] = useState(insuranceData);

  const [statename, setstatename] = useState("");

  React.useEffect(() => {
    //GetStateDetails();
    GetPatientData();
    GetInsuranceData();
  }, []);

  const navigate = useNavigate();
  let InsuranceNumber: number = 5568215439;

  return (
    <div>
      {/* {JSON.stringify(handleDetails)} */}
      <div className="card" style={stylestart.container}>
        <h4
          style={{
            textAlign: "left",
            paddingLeft: matches == false ? "16px" : "40px",
            paddingTop: "10px",
          }}
        >
          Profile
        </h4>
      </div>

      <div className="card" style={styletwo.container}>
        <div className="row">
          <div className="col-sm-4">
            <p style={{ textAlign: "left" }}>
              <strong>First Name </strong>
              <br></br>
              <label style={{ color: "Black" }}>
                {/* FB 8568 */}
                <h6>{isGuardian ? guardian.Auth_FirstName : patient.PatientFirstName}</h6>
              </label>
            </p>
          </div>
          <div className="col-sm-3">
            <p style={{ textAlign: "left" }}>
              <strong> Last Name </strong>
              <br></br>
              <label>
                {/* FB 8568 */}
                <h6>{isGuardian ? guardian.Auth_LastName : patient.PatientLastName}</h6>
              </label>
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-4">
            <p style={{ textAlign: "left" }}>
              <strong>Date of birth </strong>
              <br></br>
              <label>
                {/* <h6>{new Date(patient.PatientDOB).toDateString()} </h6> */}
                {/* FB 8568 */}
                <h6>{new Date(isGuardian ? guardian.Auth_DOB : patient.PatientDOB).toLocaleDateString()} </h6>
              </label>
            </p>
          </div>
          {/* FB 8568 */}
          {isGuardian ? "" :
            <div className="col-sm-3">
              <p style={{ textAlign: "left" }}>
                <strong>Gender </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientGender}</h6>
                </label>
              </p>
            </div>
          }
        </div>
        {/* FB 8568 */}
        {isGuardian ? "" : <>
          <div className="row">
            <div className="col-sm-4">
              <p style={{ textAlign: "left" }}>
                <strong>Address </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientPrimaryAddress}</h6>
                </label>
              </p>
            </div>
            <div className="col-sm-3">
              <p style={{ textAlign: "left" }}>
                <strong> Address 2 </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientSecondAddress}</h6>
                </label>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <p style={{ textAlign: "left" }}>
                <strong>City </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientCity}</h6>
                </label>
              </p>
            </div>
            <div className="col-sm-2">
              <p style={{ textAlign: "left" }}>
                <strong>State </strong>
                <br></br>
                <label>
                  <h6>{statename}</h6>
                </label>
              </p>
            </div>
            <div className="col-sm-2">
              <p style={{ textAlign: "left" }}>
                <strong>Zip code </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientZIP}</h6>
                </label>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <p style={{ textAlign: "left" }}>
                <strong>Phone Number </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientCellPhone}</h6>
                </label>
              </p>
            </div>
            <div className="col-sm-4">
              <p style={{ textAlign: "left" }}>
                <strong>Email </strong>
                <br></br>
                <label>
                  <h6>{patient.PatientEmail}</h6>
                </label>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <p style={{ textAlign: "left" }}>
                <strong>Insurance ID </strong>
                <br></br>
                <strong>Pri: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_INSURANCE_CARRIER}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Sec: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_SECONDARY_INSURANCE_CARRIER}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Tert: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_THIRD_INSURANCE_CARRIER}</h6>
                  ))}
                </label>
              </p>
            </div>

            <div className="col-sm-2">
              <p style={{ textAlign: "left" }}>
                <strong>Group </strong>
                <br></br>
                <strong>Pri: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_INSURANCE_CARRIER_GROUP}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Sec: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Tert: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_THIRD_INSURANCE_CARRIER_GROUP}</h6>
                  ))}
                </label>
              </p>
            </div>
            <div className="col-sm-2">
              <p style={{ textAlign: "left" }}>
                <strong>Insurance Number </strong>
                <br></br>
                <strong>Pri: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_INSURANCE_CARRIER_ID}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Sec: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_SECONDARY_INSURANCE_CARRIER_ID}</h6>
                  ))}
                </label>
                <br></br>
                <strong>Tert: </strong>
                <label>
                  {insuranceData.map((x: any) => (
                    <h6>{x.PATIENT_THIRD_INSURANCE_CARRIER_ID}</h6>
                  ))}
                </label>
              </p>
            </div>
          </div>

          <div style={{ justifyContent: "left", display: props.isAdmin ? "none" : "block" }}>
            <p>
              If you have any changes on above information please{" "}
              <a href="javascript:void(0);" onClick={handleClickOpen}>
                click here
              </a>{" "}
              to notify facility manager
            </p>
            <div className="col-sm-12">
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Updates In Details</DialogTitle>
                <DialogContent>
                  <DialogContentText>(Max 250 characters)</DialogContentText>

                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={8}
                    style={{
                      height: "200px",
                    }}
                    onChange={handleChange}
                  />
                </DialogContent>
                <DialogActions>
                  <button
                    className="btn"
                    style={button.container}
                    disabled={isDisabled}
                    onClick={handleEmail}
                  >
                    Notify Admin
                  </button>{" "}
                  &nbsp;
                  <a
                    className="btn"
                    style={button.container}
                    onClick={handleClose}
                  >
                    Cancel
                  </a>{" "}
                  &nbsp;
                  {/* <Button onClick={handleEmail}>Notify Admin</Button> */}
                </DialogActions>
              </Dialog>
            </div>
          </div>
          {/* FB 8568 */}
        </>
        }
      </div>
    </div>
  );
}

const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    backgroundColor: "#F8F8F8",
  },
};

const text = {
  container: {
    borderRadius: "5px",
    height: "35px",
  },
};

const card = {
  container: {},
};
